export default __webpack_public_path__ + "static/media/cross.4eb8e1cf.svg";